export default {
    namespaced: true,
    state: () => ({
        status: "Any",
        search: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        collection : "3",
    }),
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
            state.tableOptions.page = 1;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
            state.tableOptions.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getStatus: (s) => s.status,
        getSearch: (s) => s.search,
        getCollection: (s) => s.collection,
    }
}